import { Box, Button, Flex, InfoIconWithTooltip, Separator, SubTitle, Text } from "@shared/primitive-components"
import { navigationWithAltClick } from "@shared/utils/helpers/navigationWithAltClick"
import { Lozenge } from "."
import { rebatesStyles as styles } from "../styles"

export type SummaryCardMainTextProps = {
  description?: string
  expand?: { label: string; path: string }
  hasData?: boolean
  loading?: boolean
  main: string
  target?: string
  targetTooltip?: JSX.Element
  tooltip?: JSX.Element
}

export const SummaryCardMainText = ({
  description,
  expand,
  hasData,
  loading,
  main,
  target,
  targetTooltip,
  tooltip,
}: SummaryCardMainTextProps) => (
  <>
    <Box as="span">
      <Flex flexDirection="row" justifyContent="space-between" alignItems="baseline">
        <Box>
          <Flex>
            <SubTitle>{main}</SubTitle>
            {tooltip && <InfoIconWithTooltip content={tooltip} />}
          </Flex>
          <Separator size="block" color="yellow" css={styles.subTitleSeparator} />
        </Box>
        {target && <Lozenge title={target} tooltipContent={targetTooltip} />}
        {expand?.label && !loading && (
          <Button
            disabled={!hasData}
            onClick={(e: React.MouseEvent<HTMLElement>) =>
              navigationWithAltClick(`${expand.path}`, e, `${window.location.href.replace(/\?.*/, ``)}/..`, true)
            }
          >
            {expand.label.toUpperCase()}
          </Button>
        )}
      </Flex>
    </Box>
    {description && <Text css={styles.text}>{description}</Text>}
  </>
)

SummaryCardMainText.defaultProps = {
  description: undefined,
  expand: undefined,
  hasData: false,
  loading: undefined,
  target: undefined,
  targetTooltip: undefined,
  tooltip: undefined,
}
